import {
  Component,
  computed,
  InputSignal,
  InputSignalWithTransform,
  input,
  ChangeDetectionStrategy,
  Signal,
} from '@angular/core';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {
  IColorSchema,
  injectColorSchema,
} from '../../../services/infrastructure/page/browser/color-schema/inject-color-schema';
import {SpinnerSize} from '../../../common/enums/spinner.enum';
import {ThemeColor} from '../../../common/enums/theme-color.enum';

const SPINNER_SIZE_CLASSES: Record<SpinnerSize, string> = {
  [SpinnerSize.XSmall]: 'mat-spinner--xsmall',
  [SpinnerSize.Small]: 'mat-spinner--small',
  [SpinnerSize.Medium]: 'mat-spinner--middle',
  [SpinnerSize.Large]: 'mat-spinner--large',
  [SpinnerSize.XLarge]: 'mat-spinner--xlarge',
};

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  imports: [MatProgressSpinner],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {

  private readonly colorSchema: IColorSchema = injectColorSchema();

  public color: InputSignal<ThemeColor | null> = input<ThemeColor | null>(null);

  public size: InputSignalWithTransform<SpinnerSize, SpinnerSize | `${SpinnerSize}`> = input<SpinnerSize, SpinnerSize | `${SpinnerSize}`>(
    SpinnerSize.Medium,
    {transform: (size: SpinnerSize | `${SpinnerSize}`): SpinnerSize => size as SpinnerSize},
  );

  protected readonly spinnerColor: Signal<ThemeColor | null> = computed(() => this.color() || this.colorSchema.buttonColor);

  protected readonly sizeClass: Signal<string> = computed(() => SPINNER_SIZE_CLASSES[this.size()] ?? '');

}
